export default "__VITE_ASSET__CPjo2Zk$__"